import { DataHeader, DataSource, Image, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFAKProfile extends Layout {
    dataheaderFakProfile: DataHeader;
    imageRatingClass: Image;
    labelRatingClass: Label;
    panelRatingLabelAndImage: Panel;
    sourceFakProfile: DataSource;
    sourceNmfcClassOverride: DataSource;
    tableNmfcOverride: Table;
    textboxDescription: Textbox;
    textboxId: Textbox;
}
